import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { api } from '../App';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'activity', label: 'Activity' },
  { id: 'ratings', label: 'Ratings' },
  { id: 'profile', label: 'Profile' },
];

function TabButton({ tab, active, onClick }) {
  return (
    <button
      onClick={() => onClick(tab.id)}
      style={{
        padding: '12px 20px',
        background: 'transparent',
        color: active ? '#0066cc' : '#666',
        border: 'none',
        borderBottom: active ? '2px solid #0066cc' : '2px solid transparent',
        fontSize: 14,
        fontWeight: active ? 600 : 400,
        cursor: 'pointer',
        transition: 'all 0.2s',
      }}
    >
      {tab.label}
    </button>
  );
}

function OverviewTab({ user, helperProfile }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
      <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>Account Information</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ color: '#666' }}>User ID</span>
            <span style={{ fontFamily: 'monospace', fontSize: 12 }}>{user.id}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ color: '#666' }}>Email</span>
            <span>{user.email}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ color: '#666' }}>Phone</span>
            <span>{user.phone || 'Not provided'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ color: '#666' }}>User Type</span>
            <span style={{
              padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
              background: user.user_type === 'helper' ? '#28a74515' : '#0066cc15',
              color: user.user_type === 'helper' ? '#28a745' : '#0066cc',
            }}>
              {user.user_type === 'yacht_owner' ? 'Yacht Owner' : user.user_type === 'helper' ? 'Helper' : 'Admin'}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ color: '#666' }}>Status</span>
            <span style={{
              padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
              background: user.status === 'active' ? '#28a74515' : user.status === 'suspended' ? '#dc354515' : '#ffc10715',
              color: user.status === 'active' ? '#28a745' : user.status === 'suspended' ? '#dc3545' : '#ffc107',
            }}>
              {user.status}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ color: '#666' }}>Language</span>
            <span>{user.language || 'en'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ color: '#666' }}>Created</span>
            <span>{new Date(user.created_at).toLocaleDateString()}</span>
          </div>
        </div>
      </div>

      <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>Statistics</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div style={{ textAlign: 'center', padding: 20, background: '#f8f9fa', borderRadius: 8 }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#0066cc' }}>{user.stats?.requests || 0}</div>
            <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>Total Requests</p>
          </div>
          <div style={{ textAlign: 'center', padding: 20, background: '#f8f9fa', borderRadius: 8 }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#28a745' }}>{user.stats?.completed || 0}</div>
            <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>Completed</p>
          </div>
          <div style={{ textAlign: 'center', padding: 20, background: '#f8f9fa', borderRadius: 8 }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#f59e0b' }}>
              {user.stats?.avgRating || helperProfile?.average_rating || '0.0'}
            </div>
            <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>Avg Rating</p>
          </div>
          <div style={{ textAlign: 'center', padding: 20, background: '#f8f9fa', borderRadius: 8 }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#17a2b8' }}>{user.stats?.ratings || 0}</div>
            <p style={{ fontSize: 12, color: '#666', marginTop: 4 }}>Reviews</p>
          </div>
        </div>
      </div>

      {helperProfile && (
        <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', gridColumn: '1 / -1' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>Helper Profile</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20 }}>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Department</p>
              <span style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                background: '#0066cc15', color: '#0066cc',
              }}>
                {helperProfile.department ? {
                  'deck': 'Deck',
                  'interior': 'Interior',
                  'engineering': 'Engineering',
                  'galley': 'Galley',
                  'medical': 'Medical',
                  'purser': 'Purser',
                }[helperProfile.department] || helperProfile.department : 'Not set'}
              </span>
            </div>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Position</p>
              <span style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                background: helperProfile.position === 'deck_greenie' ? '#14b8a615' : '#6366f115',
                color: helperProfile.position === 'deck_greenie' ? '#14b8a6' : '#6366f1',
              }}>
                {helperProfile.position ? {
                  'deck_greenie': 'Mooring Helper (Greenie)',
                  'deck_deckhand': 'Deckhand',
                  'deck_bosun': 'Bosun',
                  'deck_mate': 'Mate/Officer',
                  'deck_captain': 'Captain',
                  'interior_steward': 'Steward/ess',
                  'interior_chief_stew': 'Chief Steward/ess',
                  'interior_purser': 'Purser',
                  'engineering_engineer': 'Engineer',
                  'engineering_eto': 'ETO',
                  'engineering_chief': 'Chief Engineer',
                  'galley_cook': 'Cook/Chef',
                  'galley_sous': 'Sous Chef',
                  'galley_head': 'Head Chef',
                }[helperProfile.position] || helperProfile.position : 'Not set'}
              </span>
            </div>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Experience</p>
              <p style={{ fontSize: 14, fontWeight: 600 }}>
                {helperProfile.experience_years || 0} year{helperProfile.experience_years !== 1 ? 's' : ''}
                {helperProfile.experience_years >= 5 && <span style={{ marginLeft: 8, color: '#f59e0b' }}>⭐ Senior</span>}
              </p>
            </div>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Bio</p>
              <p style={{ fontSize: 14 }}>{helperProfile.bio || 'No bio provided'}</p>
            </div>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Verification Status</p>
              <span style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                background: helperProfile.verification_status === 'approved' ? '#28a74515' : '#ffc10715',
                color: helperProfile.verification_status === 'approved' ? '#28a745' : '#ffc107',
              }}>
                {helperProfile.verification_status}
              </span>
            </div>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Available</p>
              <span style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                background: helperProfile.available_now ? '#28a74515' : '#dc354515',
                color: helperProfile.available_now ? '#28a745' : '#dc3545',
              }}>
                {helperProfile.available_now ? 'Yes' : 'No'}
              </span>
            </div>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Skills</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {(Array.isArray(helperProfile.skills) ? helperProfile.skills : JSON.parse(helperProfile.skills || '[]')).map(skill => (
                  <span key={skill} style={{
                    padding: '4px 10px', borderRadius: 16, fontSize: 11,
                    background: '#e0e0e0'
                  }}>{skill}</span>
                ))}
              </div>
            </div>
            <div>
              <p style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>Total Jobs</p>
              <p style={{ fontSize: 14, fontWeight: 600 }}>{helperProfile.total_jobs || 0}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ActivityTab({ activity }) {
  return (
    <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>Recent Activity</h3>
      {activity.length > 0 ? (
        <div>
          {activity.map((item, idx) => (
            <div key={idx} style={{
              display: 'flex', alignItems: 'flex-start', padding: '16px 0',
              borderBottom: idx < activity.length - 1 ? '1px solid #eee' : 'none'
            }}>
              <div style={{
                width: 36, height: 36, borderRadius: '50%',
                background: '#0066cc15', display: 'flex', alignItems: 'center', justifyContent: 'center',
                marginRight: 12, fontSize: 16
              }}>
                {item.type === 'request' ? '📋' : item.type === 'rating' ? '⭐' : item.type === 'message' ? '💬' : '📌'}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 500, fontSize: 14 }}>{item.title}</div>
                <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>{item.description}</div>
              </div>
              <div style={{ fontSize: 12, color: '#888' }}>{item.time}</div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: '#666', textAlign: 'center', padding: 40 }}>No activity yet</div>
      )}
    </div>
  );
}

function RatingsTab({ ratings }) {
  return (
    <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 600 }}>Reviews & Ratings</h3>
      {ratings.length > 0 ? (
        <div>
          {ratings.map((rating, idx) => (
            <div key={idx} style={{
              padding: '16px 0',
              borderBottom: idx < ratings.length - 1 ? '1px solid #eee' : 'none'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <div style={{ display: 'flex', gap: 4, marginRight: 12 }}>
                  {[1, 2, 3, 4, 5].map(star => (
                    <span key={star} style={{ color: star <= rating.rating ? '#f59e0b' : '#e0e0e0', fontSize: 16 }}>★</span>
                  ))}
                </div>
                <span style={{ fontSize: 12, color: '#666' }}>
                  {new Date(rating.created_at).toLocaleDateString()}
                </span>
              </div>
              {rating.comment && (
                <p style={{ fontSize: 14, color: '#333', margin: 0 }}>{rating.comment}</p>
              )}
              <p style={{ fontSize: 12, color: '#888', marginTop: 8 }}>
                By: {rating.rater_name || 'Anonymous'}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: '#666', textAlign: 'center', padding: 40 }}>No ratings yet</div>
      )}
    </div>
  );
}

function ProfileTab({ user, helperProfile, onSave }) {
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    email: user.email || '',
    phone: user.phone || '',
    status: user.status || 'active',
  });

  const handleSave = async () => {
    await onSave(formData);
    setEditing(false);
  };

  return (
    <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>Edit Profile</h3>
        {!editing ? (
          <button
            onClick={() => setEditing(true)}
            style={{
              padding: '8px 16px', background: '#0066cc', color: 'white',
              border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer'
            }}
          >
            Edit
          </button>
        ) : (
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => setEditing(false)}
              style={{
                padding: '8px 16px', background: '#e0e0e0', color: '#333',
                border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              style={{
                padding: '8px 16px', background: '#28a745', color: 'white',
                border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer'
              }}
            >
              Save Changes
            </button>
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 6 }}>First Name</label>
          <input
            type="text"
            value={formData.first_name}
            onChange={e => setFormData({ ...formData, first_name: e.target.value })}
            disabled={!editing}
            style={{
              width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 6,
              background: editing ? 'white' : '#f8f9fa', fontSize: 14
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 6 }}>Last Name</label>
          <input
            type="text"
            value={formData.last_name}
            onChange={e => setFormData({ ...formData, last_name: e.target.value })}
            disabled={!editing}
            style={{
              width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 6,
              background: editing ? 'white' : '#f8f9fa', fontSize: 14
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 6 }}>Email</label>
          <input
            type="email"
            value={formData.email}
            onChange={e => setFormData({ ...formData, email: e.target.value })}
            disabled={!editing}
            style={{
              width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 6,
              background: editing ? 'white' : '#f8f9fa', fontSize: 14
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 6 }}>Phone</label>
          <input
            type="text"
            value={formData.phone}
            onChange={e => setFormData({ ...formData, phone: e.target.value })}
            disabled={!editing}
            style={{
              width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 6,
              background: editing ? 'white' : '#f8f9fa', fontSize: 14
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 6 }}>Status</label>
          <select
            value={formData.status}
            onChange={e => setFormData({ ...formData, status: e.target.value })}
            disabled={!editing}
            style={{
              width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 6,
              background: editing ? 'white' : '#f8f9fa', fontSize: 14
            }}
          >
            <option value="active">Active</option>
            <option value="suspended">Suspended</option>
            <option value="pending">Pending</option>
          </select>
        </div>
      </div>
    </div>
  );
}

function UserDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [user, setUser] = useState(null);
  const [helperProfile, setHelperProfile] = useState(null);
  const [activity, setActivity] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [newUserType, setNewUserType] = useState('');

  useEffect(() => {
    loadUser();
  }, [id]);

  const loadUser = async () => {
    try {
      setLoading(true);
      const userData = await api(`/admin/users/${id}`);
      setUser(userData.data || userData);

      if (userData.data?.user_type === 'helper' || userData.user_type === 'helper') {
        try {
          const helperData = await api(`/admin/helpers/${id}`);
          setHelperProfile(helperData.data || helperData);
        } catch (e) {
          console.log('No helper profile');
        }
      }

      // Load activity
      try {
        const activityData = await api(`/admin/users/${id}/activity`);
        setActivity(activityData.data || []);
      } catch (e) {
        setActivity([]);
      }

      // Load ratings
      try {
        const ratingsData = await api(`/admin/users/${id}/ratings`);
        setRatings(ratingsData.data || []);
      } catch (e) {
        setRatings([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (formData) => {
    try {
      await api(`/admin/users/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(formData),
      });
      loadUser();
    } catch (err) {
      alert('Failed to update user: ' + err.message);
    }
  };

  const handleChangeType = async () => {
    if (!newUserType) return;
    try {
      await api(`/admin/users/${id}/change-type`, {
        method: 'POST',
        body: JSON.stringify({ new_type: newUserType }),
      });
      setShowTypeModal(false);
      loadUser();
    } catch (err) {
      alert('Failed to change user type: ' + err.message);
    }
  };

  const handleSuspend = async () => {
    if (!window.confirm('Are you sure you want to suspend this user?')) return;
    try {
      await api(`/admin/users/${id}`, {
        method: 'PATCH',
        body: JSON.stringify({ status: 'suspended' }),
      });
      loadUser();
    } catch (err) {
      alert('Failed to suspend user: ' + err.message);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this user? This action cannot be undone.')) return;
    try {
      await api(`/admin/users/${id}`, {
        method: 'DELETE',
      });
      navigate('/users');
    } catch (err) {
      alert('Failed to delete user: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <div style={{
          width: 40, height: 40,
          border: '3px solid #e0e0e0', borderTop: '3px solid #0066cc',
          borderRadius: '50%', animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }} />
        <p style={{ color: '#666' }}>Loading user...</p>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!user) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: '#dc3545' }}>
        User not found
        <br /><br />
        <Link to="/users" style={{ color: '#0066cc' }}>Back to Users</Link>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <Link to="/users" style={{
            width: 40, height: 40, borderRadius: 8, background: '#f0f0f0',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            textDecoration: 'none', color: '#666', fontSize: 18
          }}>←</Link>
          <div style={{
            width: 80, height: 80, borderRadius: '50%',
            background: user.profile_photo_url ? `url(${user.profile_photo_url}) center/cover` : '#e0e0e0',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 32, color: '#666'
          }}>
            {!user.profile_photo_url && (user.first_name?.[0] || '?')}
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>
              {user.first_name} {user.last_name}
            </h1>
            <p style={{ color: '#666', fontSize: 14, marginTop: 4 }}>{user.email}</p>
            <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
              <span style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                background: user.user_type === 'helper' ? '#28a74515' : '#0066cc15',
                color: user.user_type === 'helper' ? '#28a745' : '#0066cc',
              }}>
                {user.user_type === 'yacht_owner' ? 'Yacht Owner' : user.user_type === 'helper' ? 'Helper' : 'Admin'}
              </span>
              {helperProfile && helperProfile.position && (
                <span style={{
                  padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                  background: helperProfile.position === 'deck_greenie' ? '#14b8a615' : '#6366f115',
                  color: helperProfile.position === 'deck_greenie' ? '#14b8a6' : '#6366f1',
                }}>
                  {{
                    'deck_greenie': 'Mooring Helper',
                    'deck_deckhand': 'Deckhand',
                    'deck_bosun': 'Bosun',
                    'deck_mate': 'Mate/Officer',
                    'deck_captain': 'Captain',
                    'interior_steward': 'Steward/ess',
                    'interior_chief_stew': 'Chief Stew',
                    'interior_purser': 'Purser',
                    'engineering_engineer': 'Engineer',
                    'engineering_eto': 'ETO',
                    'engineering_chief': 'Chief Engineer',
                    'galley_cook': 'Cook/Chef',
                    'galley_sous': 'Sous Chef',
                    'galley_head': 'Head Chef',
                  }[helperProfile.position] || helperProfile.position}
                </span>
              )}
              {helperProfile && helperProfile.experience_years > 0 && (
                <span style={{
                  padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                  background: '#f59e0b15', color: '#f59e0b',
                }}>
                  {helperProfile.experience_years} yr{helperProfile.experience_years !== 1 ? 's' : ''} exp
                </span>
              )}
              <span style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 500,
                background: user.status === 'active' ? '#28a74515' : '#dc354515',
                color: user.status === 'active' ? '#28a745' : '#dc3545',
              }}>
                {user.status}
              </span>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={() => { setNewUserType(user.user_type); setShowTypeModal(true); }}
            style={{
              padding: '10px 16px', background: '#17a2b8', color: 'white',
              border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer'
            }}
          >
            Change Type
          </button>
          <button
            onClick={handleSuspend}
            style={{
              padding: '10px 16px', background: '#ffc107', color: '#333',
              border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer'
            }}
          >
            Suspend
          </button>
          <button
            onClick={handleDelete}
            style={{
              padding: '10px 16px', background: '#dc3545', color: 'white',
              border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer'
            }}
          >
            Delete
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{
        display: 'flex', borderBottom: '1px solid #eee', marginBottom: 24,
        background: 'white', borderRadius: '12px 12px 0 0', padding: '0 8px'
      }}>
        {TABS.map(tab => (
          <TabButton key={tab.id} tab={tab} active={activeTab === tab.id} onClick={setActiveTab} />
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && <OverviewTab user={user} helperProfile={helperProfile} />}
      {activeTab === 'activity' && <ActivityTab activity={activity} />}
      {activeTab === 'ratings' && <RatingsTab ratings={ratings} />}
      {activeTab === 'profile' && <ProfileTab user={user} helperProfile={helperProfile} onSave={handleSave} />}

      {/* Change Type Modal */}
      {showTypeModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white', borderRadius: 12, padding: 24, width: 400,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            <h3 style={{ margin: '0 0 20px 0', fontSize: 18, fontWeight: 600 }}>Change User Type</h3>
            <p style={{ color: '#666', fontSize: 14, marginBottom: 16 }}>
              This will change the user's profile type. If switching to helper, a helper profile will be created.
            </p>
            <select
              value={newUserType}
              onChange={e => setNewUserType(e.target.value)}
              style={{
                width: '100%', padding: 12, border: '1px solid #ddd', borderRadius: 6,
                fontSize: 14, marginBottom: 20
              }}
            >
              <option value="yacht_owner">Yacht Owner</option>
              <option value="helper">Helper</option>
              <option value="admin">Admin</option>
            </select>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowTypeModal(false)}
                style={{
                  padding: '10px 20px', background: '#e0e0e0', color: '#333',
                  border: 'none', borderRadius: 6, fontSize: 14, cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleChangeType}
                style={{
                  padding: '10px 20px', background: '#0066cc', color: 'white',
                  border: 'none', borderRadius: 6, fontSize: 14, cursor: 'pointer'
                }}
              >
                Change Type
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserDetail;
